import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../helpers"

const baseAvatarClassName = cva("relative flex shrink-0 rounded-full justify-center items-center", {
  variants: {
    size: {
      sm: "h-8 w-8",
      md: "h-12 w-12",
      lg: "h-14 w-14",
      xl: "h-16 w-16",
    },
    disabled: {
      true: "bg-neutral-50",
      false: "bg-neutral-100",
    },
    backgroundColor: {
      white: "bg-white",
      neutral100: "bg-neutral-100",
    },
  },

  defaultVariants: {
    size: "md",
    backgroundColor: "white",
  },
})

const badgeClassName = cva(
  "bg-blurple-500 rounded-full border border-white absolute -top-1 -right-1",
  {
    variants: {
      size: {
        sm: "h-2 w-2",
        md: "h-5 w-5",
        lg: "h-5 w-5",
        xl: "h-5 w-5",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
)

const avatarImage = (className?: string) =>
  cn("aspect-square h-full w-full overflow-hidden rounded-full", className)

type AvatarVariants = VariantProps<typeof baseAvatarClassName>;
export type AvatarSize = NonNullable<AvatarVariants["size"]>;

export { baseAvatarClassName, badgeClassName, avatarImage }
